/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { RestServiceProvider } from '../../RestServiceProvider';
import { EquipmentService } from './EquipmentService';

class EquipmentServiceProvider extends RestServiceProvider {
    getServiceInstance($q, resource, $httpParamSerialiserJQLike, $log) {
        return new EquipmentService($q, resource, $httpParamSerialiserJQLike, $log);
    }
}

export { EquipmentServiceProvider };



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/equipment/service/EquipmentServiceProvider.js